import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMaskModule } from 'ngx-mask';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomMatDeleteDialogModule } from '../custom-mat-delete-popup/custom-mat-delete-dialog.module';
import { CustomMatFormDialogModule } from '../custom-mat-form-dialog/custom-mat-form-dialog.module';
import { CustomSearchSelectModule } from '@module/custom-mat-search-select/custom-searchselect.module';
import { CustomDataTableComponent } from './custom-data-table.component';

@NgModule({
  declarations: [
    CustomDataTableComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    NgxMaskModule,
    MatTooltipModule,    
    CustomMatDeleteDialogModule,
    CustomMatFormDialogModule,
    CustomSearchSelectModule
  ],
  exports: [
    CustomDataTableComponent,
  ]
})

export class CustomDataTableModule {
}
